import React from "react";
import { Button, Tree, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useCustomerModel } from "../baseCustomerModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
export const DataBox = () => {
    const { selectedData, selectedRowKeys, updateEditFormVal, loadData, importCustomer, exportCustomer, downloadTpl, transferCustomer } = useCustomerModel();
    const { selectedNavId, addNav, findNav, selectNav, replaceNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {

        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let customerEditKey = "13-5-1-2";
        let isFindNav = findNav(customerEditKey);
        if (!isFindNav) {
            addNav(customerEditKey, { id: selectedRowKeys[0], mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "客户跳转详情",
                title: Locale["Jump to the detail page"],
                type: "warning",
                // text: "您还有客户详情未保存，是否跳转",
                text: Locale["The detail page has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(customerEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }
    const goVehicle = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行车辆", type: "warning" });
            return;
        }
        replaceNav(
            selectedNavId,
            "13-5-2",
            {
                id: "",
                mode: "add",
                parentInfo: {
                    customerName: selectedData?.name,
                    selectedNavId,
                }
            },
            true
        )
    }
    const action = <>
        <AuthButton
            // resCode="CustomerManagementAdd"
            resCode={ResourcesAuthBtn[mianCode]["CustomerManagementAdd"]}
            onClick={() => addNav("13-5-1-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="CustomerManagementEdit"
            resCode={ResourcesAuthBtn[mianCode]["CustomerManagementEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="CustomerManagementImport"
            resCode={ResourcesAuthBtn[mianCode]["CustomerManagementImport"]}
        >
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/customer/import`, loadData)}>
                <Button className="mr-5" type="link" shape="round">{Locale["Import"]}</Button>
            </Upload>
        </AuthButton>
        <AuthButton
            // resCode="CustomerManagementDownloadTheTemplate"
            resCode={ResourcesAuthBtn[mianCode]["CustomerManagementDownloadTheTemplate"]}
            onClick={() => { downloadTpl() }}
            // name="下载模板"
            name={Locale["Download template"]}
        />
        <AuthButton
            // resCode="CustomerManagementSubordinateVehicle"
            resCode={ResourcesAuthBtn[mianCode]["CustomerManagementSubordinateVehicle"]}
            onClick={() => { goVehicle() }}
            // name="下属车辆"
            name={Locale["Subordinate Vehicle"]}
        />

        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { addNav("13-5-1-1", { id: "", mode: "add" }) }}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/customer/import`, loadData)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl() }}
        >下载模板</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goVehicle()}
        >下属车辆</Button> */}
    </>;

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}
